// SamplingEventsMenu.js
// Expandable menu for Sampling Events with submenu options: MST and Calibration Logs.

import React from "react";
import { useAppStore } from "../../../../store/appStore";
import styles from "./SamplingEventsMenu.module.css";

const SamplingEventsMenuOptions = ({
  activeTab,
  isSamplingEventsMenuExpanded,
  onTabClick,
}) => {
  const toggleSamplingEventsMenu = useAppStore(
    (s) => s.mainMenuActions.toggleSamplingEventsMenu
  );

  const handleSubmenuClick = (tabName) => {
    onTabClick(tabName);
    // Close the submenu on mobile and tablet screens
    if (window.innerWidth < 1024) {
      toggleSamplingEventsMenu();
    }
  };

  return (
    <div
      className={`${styles.samplingEventsMenuContainer} ${
        isSamplingEventsMenuExpanded ? styles.expanded : ""
      }`}
      data-testid="sampling-events-menu-options"
    >
      {/* MST (Manual Sampling - the existing sampling events table) */}
      <button
        className={`${styles.tabButton} ${
          activeTab === "samplingEvents" ? styles.active : ""
        }`}
        onClick={() => handleSubmenuClick("samplingEvents")}
        data-testid="mst-sampling-tab"
      >
        MST
      </button>

      {/* Calibration Logs */}
      <button
        className={`${styles.tabButton} ${
          activeTab === "calibrationLogs" ? styles.active : ""
        }`}
        onClick={() => handleSubmenuClick("calibrationLogs")}
        data-testid="calibration-logs-tab"
      >
        Calibration Logs
      </button>
    </div>
  );
};

export const SamplingEventsMenu = ({
  activeTab,
  isSamplingEventsMenuExpanded,
  mainMenuStyles,
  handleMainMenuButtonClick,
  onTabClick,
}) => {
  // Highlight the parent button if any of its child tabs are active
  const isAnySamplingTabActive =
    activeTab === "samplingEvents" || activeTab === "calibrationLogs";

  return (
    <>
      <button
        className={`${mainMenuStyles.tabButton} ${styles.samplingEventsButton} ${
          isAnySamplingTabActive ? styles.active : ""
        }`}
        onClick={() => handleMainMenuButtonClick("samplingEvents")}
        data-testid="sampling-events-tab"
      >
        Sampling {isSamplingEventsMenuExpanded ? "▼" : "▶"}
      </button>
      <SamplingEventsMenuOptions
        activeTab={activeTab}
        isSamplingEventsMenuExpanded={isSamplingEventsMenuExpanded}
        onTabClick={onTabClick}
      />
    </>
  );
};
